module.exports = __webpack_public_path__ + "img/alton-towers.50695265.jpg";